<template>
  <div class="traditional-enterprise">
    <div class="content-center">
      <div class="module-header">
        <div class="module-title">传统企业模式面临的挑战</div>
        <div class="module-subtitle">随着数智化的加快推进，组织在项目管理过程中，面临着数值化转型的新挑战</div>
      </div>
      <div class="module-body">
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_yrcbg.png">
          <div class="challenge-item-title">用人成本高</div>
        </div>
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_zjyld.png">
          <div class="challenge-item-title">资金压力大</div>
        </div>
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_xmnzhao.png">
          <div class="challenge-item-title">项目难找</div>
        </div>
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_zzbz.png">
          <div class="challenge-item-title">资金不足</div>
        </div>
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_xmnz.png">
          <div class="challenge-item-title">项目难做</div>
        </div>
        <div class="challenge-item">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_gylfx.png">
          <div class="challenge-item-title">供应链风险</div>
        </div>
        <div class="challenge-item half">
          <img class="challenge-item-icon" src="@/assets/img/home/TraditionalEnterprise/icon_grddddd.png">
          <div class="challenge-item-title">个人的单打独斗</div>
          <!-- <div class="challenge-item-subtitle">缺资质、缺人才、缺资金</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
};
</script>

<style lang="less" scoped>
.traditional-enterprise {
  padding: 64px 0;
  background-color: #fff;

  .content-center {
    .module-body {
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.05);

      .challenge-item {
        width: 25%;
        height: 170px;
        padding: 40px 0 0 40px;
        border: 1px solid #F5F5F5;
        background-image: url('@/assets/img/home/TraditionalEnterprise/background.png');
        background-position: right bottom;
        background-repeat: no-repeat;
        &:hover {
          .challenge-item-icon {
            animation: shake-animation 0.6s;
            @keyframes shake-animation {
              0% { transform: translateX(0); }
              20% { transform: translateX(5px); }
              40% { transform: translateX(-5px); }
              60% { transform: translateX(3px); }
              80% { transform: translateX(-3px); }
              100% { transform: translateX(0); }
            }
          }
          .challenge-item-title {
            color: @primary-color;
          }
        }

        .challenge-item-icon {
          width: 48px;
          height: 60px;
          padding-bottom: 12px;
          background-image: url('@/assets/img/home/TraditionalEnterprise/icon_shadow.png');
          background-size: 38px 14px;
          background-position: 5px bottom;
          background-repeat: no-repeat;
        }
        .challenge-item-title {
          margin-top: 14px;
          transition: 0.3s;
          cursor: default;
        }
        &.half {
          width: 50%;
          padding-top: 52px;
          display: flex;
          align-items: flex-start;

          .challenge-item-title {
            flex: 1;
            margin-top: 7px;
            margin-left: 34px;
            position: relative;
            &::after {
              content: '缺资质、缺人才、缺资金';
              font-size: 14px;
              color: @info-color;
              position: absolute;
              left: 0;
              bottom: -30px;
            }
          }
          .challenge-item-subtitle {
            margin-top: 13px;
            margin-left: 34px;
            font-size: 14px;
            color: @info-color;
          }
        }
      }
    }
  }
}
</style>
